import { RestaurantFranchise } from "@/redux/services/restaurant/restaurant.type";

/**
 * The franchise an owner works in (SFRESTO-169): the one they selected before
 * (persisted `currentFranchise`) if they still own it, otherwise the first of
 * their franchises (GET /restaurant_franchises/mine, sorted by name; the API
 * falls back to that same franchise when no X-Franchise-Id is sent).
 */
export const pickCurrentFranchise = (
  franchises: RestaurantFranchise[],
  selectedId?: string
): RestaurantFranchise | undefined =>
  franchises.find((franchise) => franchise.id === selectedId) ?? franchises[0];

/** The franchise switcher is only shown to owners of two franchises or more. */
export const shouldShowFranchiseSwitcher = (
  franchises: RestaurantFranchise[] | undefined
): boolean => (franchises?.length ?? 0) >= 2;
